import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/frontend/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/frontend/markdoc/tags.js'
import * as nodes from '/vercel/path0/frontend/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Gdzie lądują książki, które pożyczyliśmy innym?\ndescription: Poza dostępem do książek, mamy też wgląd do innych właścicieli - przeczytaj więcej...\n---\n\nBibliodesk umożliwia sprawdzanie stanu posiadania danego egzemplarza.\n\n___\n\n## Książki pożyczone innym\n\nW momencie kiedy nasza książka z kodem QR, który wygenerowaliśmy lub [kupiliśmy](https://youtalky.com/kody) zostanie zeskanowana telefonem przez innego użytkownika YouTalky - będzie on mógł dodać ją na swoją półkę. Spowoduje to zniknięcie książki z [listy książek](https://www.youtalky.com/docs/bibliodesk-egzemplarze-ksiazek-uzytkownika/) a książka pojawi się w liście __Pożyczone__.\n\n\n![Kody do katalogowania](/imgs/docs/bibliodesk/copies/bibliodesk-ksiazki-pozyczone-01.png)\n\n\n{% callout type=\"note\" title=\"Czy wiesz, że...\" %}\n\nbędziesz mieć wgląd w profile użytkowników, którzy dodali ją na swoją półkę? Otwórz szczegóły książki i sprawdź panel z prawej strony.\n\n{% /callout %}\n\n\n![Kody do katalogowania](/imgs/docs/bibliodesk/copies/bibliodesk-ksiazki-pozyczone-02.png)\n\n## Książki pożyczone nam\n\nNa ten półce znajduje się lista książek, które zeskanowaliśmy od innych.";
const filepath = "/docs/bibliodesk-nasze-ksiazki-na-polkach-u-innych.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
